import { render, staticRenderFns } from "./businessguide.vue?vue&type=template&id=58c3e5b0&"
import script from "./businessguide.vue?vue&type=script&lang=js&"
export * from "./businessguide.vue?vue&type=script&lang=js&"
import style0 from "./businessguide.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports